/**
 * URL segments shared between the AutoOps router, path builder,
 * and breadcrumb hrefs. The two modes (deployment vs CCM) share
 * the same internal resource — only the URL surface differs.
 */
export const URL_SEGMENTS = {
  DEPLOYMENTS: 'deployments',
  CLUSTERS: 'clusters',
  DEPLOYMENT_PAGE: 'deployment',
  CLUSTER_PAGE: 'cluster',
  DEPLOYMENTS_LIST: 'deployments',
  CONNECTED_CLUSTERS_LIST: 'connected-clusters',
} as const;

export const RESOURCE_TYPE = {
  DEPLOYMENT: 'DEPLOYMENT',
  CCM: 'CCM',
} as const;

export type ResourceType = (typeof RESOURCE_TYPE)[keyof typeof RESOURCE_TYPE];
